// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__267cj","wrapperContent":"Layout_wrapperContent__1nOK-"};